import { render } from "./form-input-text.vue?vue&type=template&id=46816f10"
import script from "./form-input-text.vue?vue&type=script&lang=js"
export * from "./form-input-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__